import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';

import RolePage from './pages/role/RolePage';
import EditPage from './pages/edit/EditPage';

import { useStore } from '../../stores';

import styles from './ProfilePage.module.scss';

export default observer(function ProfilePage() {
    const { authStore } = useStore();

    return (
        <div className={styles.container}>
            <Switch>
                {authStore.user?.role === '' && <Route exact path="/profile/role"><RolePage/></Route>}
                <Route exact path="/profile/edit"><EditPage/></Route>
                <Route path="/profile"><Redirect to={authStore.user?.role === '' ? '/profile/role' : '/profile/edit'}/></Route>
            </Switch>
        </div>
    );
});
